module.exports = __webpack_public_path__ + "e14df27bb439e93254e2b332d64132e6.png";